import { PORTFOLIO_TABS_NAME } from '../../../constants/reports/reports-data';
import { ExchangeType } from '../../../providers/portfolio-management';

type TabName =
  | typeof PORTFOLIO_TABS_NAME.spotLadder
  | typeof PORTFOLIO_TABS_NAME.spotGrid
  | typeof PORTFOLIO_TABS_NAME.spotTime
  | typeof PORTFOLIO_TABS_NAME.pnlLegacy
  | typeof PORTFOLIO_TABS_NAME.positionsAndOrders
  | typeof PORTFOLIO_TABS_NAME.transactions
  | typeof PORTFOLIO_TABS_NAME.pnl;

interface IAccountTabs {
  perAccount: TabName[];
}

const DEFAULT_SPOT_TABS: TabName[] = [
  PORTFOLIO_TABS_NAME.spotLadder,
  PORTFOLIO_TABS_NAME.spotGrid,
  PORTFOLIO_TABS_NAME.spotTime,
];

const DEFAULT_TABS: TabName[] = [
  ...DEFAULT_SPOT_TABS,
  PORTFOLIO_TABS_NAME.pnlLegacy,
  PORTFOLIO_TABS_NAME.positionsAndOrders,
  PORTFOLIO_TABS_NAME.transactions,
  PORTFOLIO_TABS_NAME.strikeReport,
];

export const accountTabsConfig: Record<ExchangeType, IAccountTabs> = {
  binance: {
    perAccount: [
      ...DEFAULT_SPOT_TABS,
      PORTFOLIO_TABS_NAME.positionsAndOrders,
      PORTFOLIO_TABS_NAME.strikeReport,
    ],
  },
  bybit: {
    perAccount: [
      ...DEFAULT_SPOT_TABS,
      PORTFOLIO_TABS_NAME.positionsAndOrders,
      PORTFOLIO_TABS_NAME.transactions,
      PORTFOLIO_TABS_NAME.strikeReport,
    ],
  },
  coincall: {
    perAccount: [
      ...DEFAULT_SPOT_TABS,
      PORTFOLIO_TABS_NAME.positionsAndOrders,
      PORTFOLIO_TABS_NAME.transactions,
      PORTFOLIO_TABS_NAME.strikeReport,
    ],
  },
  bullish: {
    perAccount: [
      ...DEFAULT_SPOT_TABS,
      PORTFOLIO_TABS_NAME.positionsAndOrders,
      PORTFOLIO_TABS_NAME.transactions,
      PORTFOLIO_TABS_NAME.strikeReport,
    ],
  },
  deribit: {
    perAccount: [...DEFAULT_TABS, PORTFOLIO_TABS_NAME.pnl],
  },
  okx: {
    perAccount: [...DEFAULT_TABS, PORTFOLIO_TABS_NAME.pnl],
  },
  otc: {
    perAccount: [
      ...DEFAULT_SPOT_TABS,
      PORTFOLIO_TABS_NAME.pnl,
      PORTFOLIO_TABS_NAME.positionsAndOrders,
      PORTFOLIO_TABS_NAME.strikeReport,
      PORTFOLIO_TABS_NAME.transactions,
    ],
  },
};

export const aggregatedTabs: TabName[] = [
  ...DEFAULT_SPOT_TABS,
  PORTFOLIO_TABS_NAME.pnl,
  PORTFOLIO_TABS_NAME.strikeReport,
];
